import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const OrganizationPage_OneOrganization_QueryDocument = graphql(`
  query OrganizationPage_OneOrganization_Query($id: Id!) {
    findOneOrganization(id: $id) {
      _id
      code
      isInternal
      name
      ...OrganizationPage_Tabs_Organization_Fragment
      ...ActorCardCmp_Organization_Fragment
    }
  }
`);

export type OrganizationPage_OneOrganization = ResultOf<
  typeof OrganizationPage_OneOrganization_QueryDocument
>['findOneOrganization'];

export const useFindOneOrganizationQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    OrganizationPage_OneOrganization_QueryDocument,
    { id },
    { enabled: !!id },
  );
